import {h, Component} from 'preact';
import {PropTypes} from 'preact-compat';

class ImageInput extends Component {
    componentDidMount() {
        const propertyImage = {};
        const maxFileSize = '3mb';
        const maxFileSizeForHumans = '3 MB';
        const photoUploader = new SimpleFileUploader({
            uploadDir: 'tmp',
            isPdfAllowed: false,
            isPdfOnly: false,
            allowedMimeTypes: ['image/jpeg', 'image/png', 'image/gif', 'image/bmp'],
            pluploadOptions: {
                browse_button: this.propertyImageInputContainer || $('#propertyImageInputContainer'),
                max_file_count: 1,
                resize: {
                    width: 800,
                    height: 450
                },
                max_file_size: maxFileSize,
                max_retries: 3,
                filters: {
                    prevent_duplicates: true
                }
            },
            onUploadStarted: () => {
                this.setState({uploading: true});
                if (this.props.onUploading) {
                    this.props.onUploading(true);
                }
            },
            onFileUploaded: (file, url, response) => {
                if (checkAjax(response)) {
                    propertyImage.file = 'tmp/' + response.tempFileName;
                    propertyImage.src = url;
                    this.setState({uploading: false});
                    this.props.onChange({...propertyImage});
                }
            },
            onError: e => {
                let error = `Sorry, couldn't upload this file. Please make sure it's an image and is smaller than
                    ${maxFileSizeForHumans} and not smaller than 335 pixels on any side
                    .`;
                if (e && e.message.includes('Content-Type not allowed')) {
                    error =
                        'Sorry, but the image format is not allowed, we currently only support JPEG, PNG, JPG. File size must be below 3 MB.';
                }

                if (this.props.onUploading) {
                    defaultAjaxError(error);
                    if (this.props.onUploading) {
                        this.setState({uploading: false});
                    }
                    this.props.onUploading(false);
                }
            }
        });
    }

    render() {
        const {className, style, ...rest} = this.props;
        const classes = className ? ['image-input-button', ...className.split(' ')].join(' ') : 'image-input-button';
        return (
            <div>
                <input
                    id="propertyImage"
                    type="file"
                    name="propertyImage"
                    accept="image/*"
                    style="display: none;"></input>
                {this.state.uploading && (
                    <div className={classes}>
                        <span className="uploading-image-text">Uploading</span>
                    </div>
                )}
                <div
                    id="propertyImageInputContainer"
                    ref={el => (this.propertyImageInputContainer = el)}
                    className={classes}
                    style={this.state.uploading ? {display: 'none'} : style}
                    {...rest}>
                    {!this.state.uploading && this.props.children
                        ? this.props.children
                        : [
                              <span className="hidden-xs">Upload Image</span>,
                              <i className="icon-image-camera-outline visible-xs" />
                          ]}
                </div>
            </div>
        );
    }
}

export default ImageInput;
